import React from "react"
import { formatLink } from "../functions"
import { formatFocusedImage } from "../organism-formatting/formatBaseMolecules"
import { Link } from "gatsby"

export const formatNavPromo = (data, homepageSlug, currentLocale) => {
  const returnData = {
    id: data?.id,
    pageLink: {
      external:
        data?.pageLink?.__typename === "ContentfulExternalLink" ? true : false,
      url:
        data?.pageLink?.__typename === "ContentfulExternalLink"
          ? data?.pageLink?.url
          : data?.pageLink?.slug
          ? formatLink(
              `/${data?.pageLink?.slug}`,
              currentLocale,
              data?.pageLink?.__typename,
              homepageSlug
            )
          : data?.pageLink?.__typename === "ContentfulProductDetailPage"
          ? `/${currentLocale}/products/${data?.pageLink?.productName
              ?.split(" ")
              ?.join("-")
              ?.toLowerCase()}/buy`
          : null,
      text: data?.pageLinkLabel || "Read more",
    },
    title: data?.title,
    image: formatFocusedImage(data?.image),
    description: data?.description,
    Link: Link,
  }
  return returnData
}
